var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "payment-header" } },
    [
      _c(
        "div",
        {
          staticClass:
            "container-1200 d-flex align-items-center justify-content-between text-align-center",
        },
        [
          _c(
            "ib-button",
            {
              attrs: {
                variant: "black",
                outline: "",
                size: "sm",
                "font-family": "medium",
                "submit-button": "",
              },
              on: { click: _vm.onClickBackBtn },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("pages.pricing.backToIdeaBuddy")) + " "
              ),
            ]
          ),
          !_vm.paymentLoading && _vm.subscriptionAlertText
            ? _c("subscription-alert", {
                staticClass: "d-none d-md-block",
                attrs: { text: _vm.subscriptionAlertText },
              })
            : _vm._e(),
          _vm.isFreeTrial && !_vm.isFreeTrialExpired
            ? _c("p", { staticClass: "d-none d-md-block current-plan" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("pages.pricing.yourCurrentPlanIs")) + " "
                ),
                _c("span", { staticClass: "payment-plan" }, [
                  _vm._v("Free Trial"),
                ]),
              ])
            : _vm._e(),
          !_vm.isFreeTrial && _vm.isSubscribed
            ? _c("p", { staticClass: "d-none d-md-block current-plan" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("pages.pricing.yourCurrentPlanIs")) + " "
                ),
                _c("span", { staticClass: "payment-plan" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.subscriptionPlanName) +
                      " / " +
                      _vm._s(_vm.currentUserSubscription.ideas) +
                      " " +
                      _vm._s(
                        Number(_vm.currentUserSubscription.ideas) > 1
                          ? "ideas"
                          : "idea"
                      ) +
                      " / " +
                      _vm._s(
                        _vm.paymentTypes[_vm.currentUserSubscription.type]
                      ) +
                      " "
                  ),
                ]),
              ])
            : _vm._e(),
          _c("img", {
            attrs: {
              src: require("@/assets/img/logos/ideaBuddy-color.svg"),
              alt: "",
            },
          }),
        ],
        1
      ),
      !_vm.paymentLoading && _vm.subscriptionAlertText
        ? _c("subscription-alert", {
            staticClass: "d-md-none text-center",
            attrs: { text: _vm.subscriptionAlertText },
          })
        : _vm._e(),
      _vm.isFreeTrial && !_vm.isFreeTrialExpired
        ? _c("p", { staticClass: "d-md-none current-plan text-center" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("pages.pricing.yourCurrentPlanIs")) + " "
            ),
            _c("span", { staticClass: "payment-plan" }, [_vm._v("Free Trial")]),
          ])
        : _vm._e(),
      !_vm.isFreeTrial && _vm.isSubscribed
        ? _c("p", { staticClass: "d-md-none current-plan text-center" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("pages.pricing.yourCurrentPlanIs")) + " "
            ),
            _c("span", { staticClass: "payment-plan d-block" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.subscriptionPlanName) +
                  " / " +
                  _vm._s(_vm.currentUserSubscription.ideas) +
                  " " +
                  _vm._s(
                    Number(_vm.currentUserSubscription.ideas) > 1
                      ? "ideas"
                      : "idea"
                  ) +
                  " / " +
                  _vm._s(_vm.paymentTypes[_vm.currentUserSubscription.type]) +
                  " "
              ),
            ]),
          ])
        : _vm._e(),
      _c("ib-divider", { attrs: { block: "" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }